/**
 * This file contains utilities for using client hints for user preference which
 * are needed by the server, but are only known by the browser.
 *
 * Color scheme is handled by the pre-paint theme bootstrap and its live media
 * query subscription rather than duplicated as a client hint.
 */
import { getHintUtils } from "@epic-web/client-hints";
import { clientHint as timeZoneHint } from "@epic-web/client-hints/time-zone";

const hintsUtils = getHintUtils({
  timeZone: timeZoneHint,
  // add other hints here (color scheme is handled by theme-bootstrap)
});
export const { getHints } = hintsUtils;

/**
 * @returns inline script element that checks for client hints and sets cookies
 * if they are not set then reloads the page if any cookie was set to an
 * inaccurate value.
 */
export function ClientHintCheck({ nonce }: { nonce: string }) {
  // Client-hint cookie sync triggers full page reloads; skip in dev to avoid refresh loops.
  if (import.meta.env.DEV) {
    return null;
  }

  return (
    <script
      nonce={nonce}
      dangerouslySetInnerHTML={{
        __html: hintsUtils.getClientHintCheckScript(),
      }}
    />
  );
}
